import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import TrainingEventsServices from "./TrainingEvents.services";
import {downloadDocument} from '../../../components/gestorDocumental/GestorDocumental';

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getTrainingEvents = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_TRAINING_EVENTS,
      payload: true,
    });
    const resp = await TrainingEventsServices.getTrainingEvents(filters);
    dispatch({
      type: actions.GET_TRAINING_EVENTS,
      payload: resp.data,
    });
    dispatch({
      type: actions.TRAINING_EVENTS_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response.status) {
          switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.TRAINING_EVENTS_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_TRAINING_EVENTS,
      payload: false,
    });
  }
};

export const getTrainingEventsById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_TRAINING_EVENTS,
      payload: true,
    });
    const resp = await TrainingEventsServices.getTrainingEventsById(id);
    dispatch({
      type: actions.GET_TRAINING_EVENTS,
      payload: resp.data,
    });
    dispatch({
      type: actions.TRAINING_EVENTS_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response.status) {
          switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.TRAINING_EVENTS_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_TRAINING_EVENTS,
      payload: false,
    });
  }
};

export const getTrainingFile = (id,setLoader) => async (dispatch, getState) => {
  try {
    // dispatch({
    //   type: actions.LOADING_DESCRIPTOR_MANUAL,
    //   payload: true,
    // });
    setLoader(true)
    const resp = await TrainingEventsServices.getTrainingFile(id);
    downloadDocument(`data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${resp.data.documento}`, `Convocatoria a capacitación.docx`);
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.FORM_FAIL_GENERAL_INFO,
    //   payload: message,
    // });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    setLoader(false)
    // dispatch({
    //   type: actions.LOADING_DESCRIPTOR_MANUAL,
    //   payload: false,
    // });
  }
};

export const getEmployeesResponsible = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PERSON_RESPONSIBLE,
      payload: true,
    });
    const resp = await TrainingEventsServices.getEmployeesResponsible(filters);
    dispatch({
      type: actions.GET_PERSON_RESPONSIBLE,
      payload: resp.data,
    });
    dispatch({
      type: actions.TRAINING_EVENTS_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.TRAINING_EVENTS_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_PERSON_RESPONSIBLE,
      payload: false,
    });
  }
};

export const saveTrainingEvents = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_TRAINING_EVENTS,
      payload: true,
    });
    const resp = await TrainingEventsServices.saveTrainingEvents(req);
    const { data, count } = getState().trainingEvents.trainingEvents;
    dispatch({
      type: actions.GET_TRAINING_EVENTS,
      payload: {
        count: count + 1,
        data: [...data, resp.data],
      },
    });
    dispatch({
      type: actions.FORM_TRAINING_EVENTS_FAIL,
      payload: "",
    });
    setShowModal(false);
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response.status) {
          switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.TRAINING_EVENTSText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_TRAINING_EVENTS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_TRAINING_EVENTS,
      payload: false,
    });
  }
};

export const editTrainingEvents = (req, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_TRAINING_EVENTS,
        payload: true,
      });
      await TrainingEventsServices.editTrainingEventsCompanies(req.id, 
        {
          listado_empresas: req.listado_empresas
        })
      delete req.listado_empresas
      const resp = await TrainingEventsServices.editTrainingEvents(req.id, req);
      const { data, count } = getState().trainingEvents.trainingEvents;
      let _data = data.slice();
      _data[index] = resp.data;
      dispatch({
        type: actions.GET_TRAINING_EVENTS,
        payload: {
          data: _data,
          count: count,
        },
      });
      dispatch({
        type: actions.FORM_TRAINING_EVENTS_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = ex.response.data[0];
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_TRAINING_EVENTS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_TRAINING_EVENTS,
        payload: false,
      });
    }
  };

export const deleteTrainingEvents = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_TRAINING_EVENTS,
      payload: true,
    });
    await TrainingEventsServices.deleteTrainingEvents(id);
    const { data, count } = getState().trainingEvents.trainingEvents;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_TRAINING_EVENTS,
      payload: {
        data: _data,
        count: count - 1,
      },
    });
    dispatch({
      type: actions.TRAINING_EVENTS_FALLA,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.respuesta) {
              message = ex.response.data.respuesta;
            } else {
              message = ex.response.data.mensaje;
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.TRAINING_EVENTS_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_TRAINING_EVENTS,
      payload: false,
    });
  }
};
